<template>
    <div class="wrapper">
        <b-modal id="idle" size="md" title="Idle User" scrollable hide-footer>
            <ModalIdle />
        </b-modal>

        <!-- Navbar -->
        <nav class="main-header navbar navbar-expand navbar-white navbar-light">
            <ul class="navbar-nav">
                <li class="nav-item">
                    <a class="nav-link" data-widget="pushmenu" href="#" role="button">
                        <i class="fas fa-bars"></i>
                    </a>
                </li>
            </ul>
        </nav>
        <!-- /.navbar -->
        <aside class="main-sidebar sidebar-dark-primary elevation-4">
            <!-- Brand Logo -->
            <a href="" class="brand-link">
                <img src="/static/AdminLTELogo.png"
                     alt="IIRMS Logo"
                     class="brand-image img-circle elevation-3"
                     style="opacity: 0.8" />
                <span class="brand-text font-weight-light">IIRMS V3</span>
            </a>
            <!-- Sidebar -->
            <div class="sidebar">
                <nav class="mt-2">
                    <ul class="nav nav-pills nav-sidebar flex-column"
                        data-widget="treeview"
                        role="menu"
                        data-accordion="false">
                        <!-- Add icons to the links using the .nav-icon class
                        with font-awesome or any other icon font library-->
                        <li class="nav-item">
                            <router-link to="/Dash" class="nav-link" replace>
                                <i class="nav-icon fas fa-chart-pie"></i>
                                <p>Dashboard</p>
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/Search" class="nav-link" replace>
                                <i class="nav-icon fas fa-search"></i>
                                <p>Search/Encode/Link</p>
                            </router-link>
                        </li>
                        <li class="nav-item" v-if="$store.getters.CRAD">
                            <router-link to="/DownloadStats" class="nav-link" replace>
                                <i class="nav-icon fas fa-chart-pie"></i>
                                <p>Download DashBoard</p>
                            </router-link>
                        </li>
                        <li class="nav-item" v-if="$store.getters.CRAD">
                            <router-link to="/Downloads" class="nav-link" replace>
                                <i class="nav-icon fas fa-search"></i>
                                <p>User Downloads</p>
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <a @click="showModal()" class="nav-link">
                                <i class="nav-icon fas fa-chart-area"></i>
                                <p>Transaction Report</p>
                            </a>
                        </li>
                        <li class="nav-item" v-if="$store.getters.CRAD">
                            <router-link to="/SoiList" class="nav-link" replace>
                                <i class="nav-icon fas fa-folder-open"></i>
                                <p>Uploaded Profiles</p>
                            </router-link>
                        </li>
                        <li class="nav-item" v-if="$store.getters.CRAD">
                            <a @click="showStat()" class="nav-link">
                                <i class="nav-icon fas fa-chart-bar"></i>
                                <p>Users Report</p>
                            </a>
                        </li>
                        <li class="nav-item" v-if="$store.getters.CRAD">
                            <a @click="showStatRegion()" class="nav-link">
                                <i class="nav-icon fas fa-chart-line"></i>
                                <p>Region Report</p>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a @click="logout()" class="nav-link">
                                <i class="nav-icon fas fa-angle-double-right"></i>
                                <p>LogOut</p>
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
        </aside>
        <!-- Content Wrapper. Contains page content -->
        <div class="content-wrapper">
            <section class="content">
                <div class="container-fluid">
                    <router-view />
                </div>
            </section>
        </div>
        <footer class="main-footer">
            <strong> Integrated Information Resource Management System </strong>

            <div class="float-right d-none d-sm-inline-block"><b>Version</b> 3</div>
        </footer>
        <b-modal id="stats"
                 size="md"
                 title="Transaction Report"
                 scrollable
                 hide-footer>
            <stat />
        </b-modal>
        <b-modal id="custom"
                 size="md"
                 title="Transaction Report By User"
                 scrollable
                 hide-footer>
            <custom />
        </b-modal>
        <b-modal id="customregion"
                 size="md"
                 title="Transaction Report Regions"
                 scrollable
                 hide-footer>
            <customregion />
        </b-modal>
    </div>
</template>

<script>
    import stat from "../components/master/UserStat";
    import custom from "../components/master/custom";
    import customregion from "../components/master/regions";
    import ModalIdle from "./ModalIdle";
    import { store } from '../store/store'
    import instance from "../helper/http";
    import { AuthURL } from "../helper";
    import checkSecMixin from "../checksec"
    import SecService from '../SecurityService'

    export default {
        data() {
            return {
                mgr: new SecService()
            }
            
        },
        components: {
            stat,
            custom,
            customregion,
            ModalIdle,
        },
        computed: {
            isIdle() {
                return this.$store.state.idleVue.isIdle;
            },
        },
        watch: {
            isIdle: function (value) {
                if (value) this.showIdle();
                else this.hideIdle();
            },
        },
        created() {
            if (!store.state.login)
            {
                let loader = this.$loading.show();
                if (sessionStorage.getItem('token'))
                {
                    this.checkProfile()
                }
                else
                {
                    this.mgr.signIn() 
                }
                loader.hide()
            }
            else if (!store.state.profile)
            {
                this.checkProfile()
            }
        },
        mixins: [checkSecMixin],
        methods: {
            showModal: function () {
                this.$bvModal.show("stats");
            },
            showStat: function () {
                this.$bvModal.show("custom");
            },
            showStatRegion: function () {
                this.$bvModal.show("customregion");
            },
            showIdle: function () {
                this.$bvModal.show("idle");
            },
            hideIdle: function () {
                this.$bvModal.hide("idle");
            },
            logout() {
                this.$store.dispatch("logout").then(() => {
                    this.mgr.signOut()
                });
            },
            checkProfile() {
                this.mgr.getAcessToken().then(token => {
                    instance.get(AuthURL + "profile", {
                        headers: { 'Authorization': 'Bearer ' + token },
                    })
                        .then((response) => {
                            store.commit("cradLog", response.data.isCrad);
                            store.commit("viewerLog", response.data.isViewer);
                            //if (response.data.changepassword) {
                            //    store.dispatch("logout");
                            //    window.location.href = '/static/changepass.html';
                            //}
                            //if (response.data.disabled) {
                            //    store.dispatch("logout");
                            //    window.location.href = '/static/disabled.html';
                            //}
                            if (!response.data.tfa) {
                                store.dispatch("logout");
                                window.location.href = '/static/twofactor.html';
                            }
                            store.commit("login", true);
                            store.commit("profile", true);
                            sessionStorage.setItem("token", token)
                           

                        })
                })
            }
        },
    };
</script>